// Ajax for Search Results

export const searchResult = () => {
  const searchLoadMoreButton = document.querySelector('.gg-search__load-more');

  if (typeof searchLoadMoreButton !== 'undefined' && searchLoadMoreButton != null) {
    searchLoadMoreButton.addEventListener('click', (e) => {
      e.preventDefault();

      const searchResults = document.querySelector('.gg-search__results');
      const maxPages = searchResults.dataset.max;
      const request = new XMLHttpRequest();
      const requestSuccessful = 200;
      const requestError = 400;

      request.open('POST', '/wp-admin/admin-ajax.php', true);
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

      request.onload = () => {
        if (request.status >= requestSuccessful && request.status < requestError) {
          const content = JSON.parse(request.response);
          searchResults.querySelector('.wrapper').innerHTML += content.data;
          searchResults.dataset.page++;

          if (searchResults.dataset.page === maxPages) {
            searchLoadMoreButton.parentNode.removeChild(searchLoadMoreButton);
          }
        }
      };
      request.onerror = () => {
        /* eslint-disable */
        console.error('An error occurred during load new post.');
        /* eslint-enable */
      };

      request.send(
        `action=search_results&max_pages=${maxPages}&current_page=${searchResults.dataset.page}&search_query=${searchResults.dataset.searchQuery}`,
      );
    });
  }
};
